import { render, staticRenderFns } from "./vXLSX.vue?vue&type=template&id=4a77a2c0"
import script from "./vXLSX.vue?vue&type=script&lang=js"
export * from "./vXLSX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports